import { REVIEWS } from '../../data/reviews';
import { assetUrl } from '../../lib/assetUrl';
import './Reviews.css';

function ReviewCard({ review }) {
  const { name, quote, image } = review;

  return (
    <li className="review-card">
      <figure>
        <div className="review-card__media">
          <img src={assetUrl(image)} alt={name} width="960" height="1280" loading="lazy" />
        </div>
        <figcaption className="review-card__body">
          <blockquote className="review-card__quote">
            <p>&ldquo;{quote}&rdquo;</p>
          </blockquote>
          <p className="review-card__name">Satisfied Customer: {name}</p>
        </figcaption>
      </figure>
    </li>
  );
}

export default function Reviews() {
  return (
    <section className="section reviews" aria-labelledby="reviews-title">
      <div className="container">
        <div className="section-heading section-heading--center">
          <p className="eyebrow">Happy patients</p>
          <h2 id="reviews-title">Reviews</h2>
        </div>
        <ul className="review-grid">
          {REVIEWS.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </ul>
      </div>
    </section>
  );
}
